module.exports = __webpack_public_path__ + "media/icons/icon-close-26f4f509.svg";